<div class="header {{ isCloseBtnDisplayed ? 'pr-16' : 'pr-4' }}">
  @if (headerIcon) {
    <svg-icon class="w-10 mr-4" preserveAspectRatio="none" [stretch]="true" [src]="headerIcon"></svg-icon>
  }

  <div class="flex flex-col flex-1 w-full">
    @if (headerTitleTemplate) {
      <span class="font-main text-2xl font-bold">
        <ng-container *ngTemplateOutlet="headerTitleTemplate"></ng-container>
      </span>
    }

    @if (headerDescription) {
      <span class="font-main text-lg text-navy-70">
        {{ headerDescription | translate }}
      </span>
    }
  </div>
</div>

<div class="content">
  <section class="flex-1 overflow-x-auto px-6 py-6">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </section>

  @if (allowFooter) {
    <section class="footer">
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </section>
  }
</div>
